var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10547 12.75L12.8516 9.00391C13.207 8.67578 13.207 8.10156 12.8516 7.77344C12.5234 7.41797 11.9492 7.41797 11.6211 7.77344L7.24609 12.1484C6.89062 12.4766 6.89062 13.0508 7.24609 13.3789L11.6211 17.7539C11.7852 17.918 12.0039 18 12.25 18C12.4688 18 12.6875 17.918 12.8516 17.7539C13.207 17.4258 13.207 16.8516 12.8516 16.5234L9.10547 12.75ZM14.3555 12.75L18.1016 9.00391C18.457 8.67578 18.457 8.10156 18.1016 7.77344C17.7734 7.41797 17.1992 7.41797 16.8711 7.77344L12.4961 12.1484C12.1406 12.4766 12.1406 13.0508 12.4961 13.3789L16.8711 17.7539C17.0352 17.918 17.2539 18 17.5 18C17.7188 18 17.9375 17.918 18.1016 17.7539C18.457 17.4258 18.457 16.8516 18.1016 16.5234L14.3555 12.75Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTargetIcon);
export default __webpack_public_path__ + "static/media/to-target-icon.1e5fd36bbd191351fa636027e9c7c97e.svg";
export { ForwardRef as ReactComponent };